<template>
  <ForgotPasswordBody/>
</template>

<script>
// @ is an alias to /src
import ForgotPasswordBody from '@/components/ForgotPasswordBody.vue'

export default {
  name: 'ForgotPasswordView',
  components: {
    ForgotPasswordBody
  }
}
</script>
